import ExternalLinksBaseHandler from '../external_links_base_handler';

/**
 * Handler for FYP
 */
class ExternalLinksCommonLinkHandler extends ExternalLinksBaseHandler {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ExternalLinksCommonLinkHandler';
    static HandlerName = 'common_link';

    /**
     *
     * @param params
     */
    init(params) {
        super.init(params);
    }

    /**
     * decide if iframe needs to be displayed
     *
     */
    display() {
        this.componentControllerRef.display();
    }


    /**
     * Handle link close
     */
    onComponentClose() {}


    /**
     * Handle overlay close button click event
     */
    onBtnCloseClicked() {}


	/**
     * Overrides base class checkPostMessageData.
	 * This handler uses "action" instead of "ActionId" so this test function must be overridden
	 * @param postMessageData
	 * @returns {boolean}
	 */
	checkPostMessageData(postMessageData) {
		if (!postMessageData || !postMessageData.action) {
			this.logger.debug('action is null or undefined');
			return false;
		}
		return true;
	}


    /**
     *
     * Overrides base class executePostMessageAction.
     * @param postMessageData
     * @returns {handleResult}
     */
	executePostMessageAction(postMessageData) {
        switch (postMessageData.action) {
            // general pages which needs to open login form will be handled in this case
            default:
                this.logger.warn('Not supported action. action = ' + postMessageData.action);
                break;
        }
    }


	/**
	 * Overrides base class executePostMessageActionFallback.
	 * This handler doesn't really care about productPackageOrigin, so we need to call executePostMessageAction either way
	 * Another approach would've been to override the origin test and make it return true
	 * @param postMessageData
	 */
	executePostMessageActionFallback(postMessageData) {
		this.executePostMessageAction(postMessageData);
	}


    getHandlerName() {
        return ExternalLinksCommonLinkHandler.HandlerName;
    }

}

export default ExternalLinksCommonLinkHandler;